import { IconeAlerta } from '../../../components/Icones'
import { dataHora } from '../../../lib/datas'
import { TEXTOS } from '../../../lib/glossario'
import type { DetalheChamado } from '../../../types/chamado'
import { parouDeAtualizar } from './atualizacaoParada'

/**
 * O aviso, no topo do detalhe, quando o chamado parou de ser atualizado.
 *
 * @param props o chamado
 * @returns o aviso, ou nada
 */
export function AvisoDeAtualizacaoParada({ chamado }: { chamado: DetalheChamado }) {
  if (!parouDeAtualizar(chamado, new Date())) {
    return null
  }
  const t = TEXTOS.chamados.atualizacaoParada
  return (
    <div role="note" className="flex gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950">
      <IconeAlerta className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" />
      <div className="min-w-0 max-w-prose space-y-1">
        <p className="font-semibold">{t.titulo(dataHora(chamado.coletadoEm))}</p>
        <p>{t.ajuda}</p>
      </div>
    </div>
  )
}
